import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "./components/ui/sonner";
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import { ChatWidget } from "./components/ChatWidget";
import { HomePage } from "./components/HomePage";
import { WindscreenCalibration } from "./components/WindscreenCalibration";

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <div className="App min-h-screen">
          <Header />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/windscreen-calibration-adelaide" element={<WindscreenCalibration />} />
          </Routes>
          <Footer />
          <ChatWidget />
          <Toaster position="top-right" />
        </div>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
